import React from 'react';
import { Accordion, AccordionItem } from './Accordion';
import { IMAGES } from '../lib/config';
const bonuses: AccordionItem[] = [{
  title: '🧾 Plantillas de Presupuesto',
  content: 'Dos modelos en PDF listos para completar e imprimir: versión clásica detallada y versión resumida para entregar en el momento. Con espacio para tus datos y los del paciente.',
  image: IMAGES.bonusPresupuesto,
  imageAlt: 'Vista previa de la plantilla de presupuesto odontológico'
}, {
  title: '📑 Modelos de Contrato: Recepcionista · Instrumentadora · Adhesión Obra Social · Alquiler de Sillón',
  content: 'Cuatro contratos editables en Word, redactados para el día a día del consultorio. Completás los datos, imprimís y firmás, sin depender de un modelo genérico de internet.',
  image: IMAGES.bonusContratos,
  imageAlt: 'Vista previa del contrato de alquiler de sillón'
}, {
  title: '🖥️ Presentación de Plan de Tratamiento',
  content: 'Una presentación profesional para mostrarle al paciente diagnóstico, alternativas, beneficios, tiempos e inversión. Cuando el paciente entiende, acepta el presupuesto.',
  image: IMAGES.bonusPlan,
  imageAlt: 'Vista previa de la presentación de plan de tratamiento'
}, {
  title: '🦷 Ilustraciones de Tratamientos (5: obturación, endodoncia, extracción, corona/prótesis, implante)',
  content: 'Cinco ilustraciones claras para explicar en segundos qué le vas a hacer al paciente. Se imprimen, se muestran en pantalla o se envían por WhatsApp.',
  image: IMAGES.bonusIlustraciones,
  imageAlt: 'Vista previa de la ilustración de endodoncia'
}, {
  title: '🧒 Odontología para Niños — manual + ilustraciones pediátricas',
  content: 'Manual de comunicación con chicos y sus familias más ilustraciones pediátricas para que la consulta sea amigable, corta y sin llanto.',
  image: IMAGES.bonusNinos,
  imageAlt: 'Vista previa del manual de odontología para niños'
}];
export function Bonuses() {
  return <section className="px-5 py-10" data-id="element-29" data-mp="3ciemd4oadwzm">
      <h2 className="text-center text-2xl font-black leading-snug text-white" data-id="element-30" data-mp="3cl99j3yopvwq">
        Además, para hacer el consultorio lo más eficiente posible, te llevás
        estos bonos:
      </h2>
      <p className="mx-auto mt-3 w-fit rounded-full bg-amber-400 px-4 py-1.5 text-xs font-extrabold uppercase tracking-wide text-[#062331]" data-id="element-31" data-mp="3lhi9qkuhkyjx">
        Gratis solo por el día de hoy
      </p>

      <div className="mt-6" data-id="element-32" data-mp="2tqc1fh4m3ujk">
        <Accordion items={bonuses} variant="amber" data-id="element-33" data-mp="2xtqv3alh49fh" />
      </div>
    </section>;
}